import type { JSX } from "react";
import type { RecentEpisodeRow } from "../../../tauri/billing";
import { fmtCost, fmtDateTime, fmtInt } from "./format";

export function EpisodesTable({ rows }: { readonly rows: readonly RecentEpisodeRow[] }): JSX.Element {
  if (rows.length === 0) {
    return <div className="p-4 text-sm text-content-tertiary">No agent episodes yet.</div>;
  }
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className="text-content-tertiary border-b border-edge">
            <th className="text-left font-medium px-3 py-2">Episode</th>
            <th className="text-left font-medium px-3 py-2">Started</th>
            <th className="text-left font-medium px-3 py-2">Ended</th>
            <th className="text-right font-medium px-3 py-2">Tokens</th>
            <th className="text-right font-medium px-3 py-2">Calls</th>
            <th className="text-right font-medium px-3 py-2">Cost</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.episode_id} className="border-b border-edge/50 last:border-b-0">
              <td className="px-3 py-2 font-mono text-content">{r.episode_id.slice(0, 8)}</td>
              <td className="px-3 py-2 text-content-secondary">{fmtDateTime(r.started_at)}</td>
              <td className="px-3 py-2 text-content-secondary">{fmtDateTime(r.endedAt)}</td>
              <td className="px-3 py-2 text-right text-content">{fmtInt(r.totalTokens)}</td>
              <td className="px-3 py-2 text-right text-content-secondary">{fmtInt(r.callCount)}</td>
              <td className="px-3 py-2 text-right text-content font-medium">{fmtCost(r.cost_micros)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
